import { simbaStyled } from '@naf-simba/theme';

export const InformationSummaryWrapper = simbaStyled('div')(({ theme }) => ({
  '&& .cta-button-body': {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(8),
  },
  '&& .cta-button-body:last-child': {
    marginBottom: 0,
  },
}));
